import React from 'react';

const LockedIcon = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' aria-hidden='true' focusable='false' height='26'>
            <path d='M0 0h64v64H0z' fill='none'></path>
            <path
                fill='#053361'
                d='M32 40.78a4.8 4.8 0 00-3.12 8.42v2.28a3.12 3.12 0 006.24 0V49.2A4.8 4.8 0 0032 40.78zm1.56 7.1a1 1 0 00-.44.82v2.78a1.12 1.12 0 01-2.24 0V48.7a1 1 0 00-.44-.82 2.8 2.8 0 113.12 0zm15.7-16.5h-.57v-14.7a16.7 16.7 0 00-33.4 0v14.7h-.56a3 3 0 00-3 3V61a3 3 0 003 3h34.52a3 3 0 003-3V34.38a3 3 0 00-3-3zM17.3 16.68a14.7 14.7 0 1129.4 0v14.7h-4.17V17.9a10.53 10.53 0 00-21.06 0v13.48H17.3zm23.23 14.7H23.47V17.9a8.53 8.53 0 0117.06 0zM50.26 61a1 1 0 01-1 1H14.74a1 1 0 01-1-1V34.38a1 1 0 011-1h34.52a1 1 0 011 1z'></path>
        </svg>
    );
};

export default LockedIcon;